import { render } from "./BaseUploadFile.vue?vue&type=template&id=63ead366&scoped=true&ts=true"
import script from "./BaseUploadFile.vue?vue&type=script&lang=ts"
export * from "./BaseUploadFile.vue?vue&type=script&lang=ts"

import "./BaseUploadFile.vue?vue&type=style&index=0&id=63ead366&scoped=true&lang=css"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63ead366"]])

export default __exports__